/*
 * @Version    : v1.00
 * @Author     : generated
 * @Date       : 2025-11-20
 * @desc       : 日语 国际化语言文件
 */
// 日语.js
export default {
  centerAgent: {
    subagency: 'サブエージェンシー',
    search: '検索',
    subagencyIncome: 'サブエージェンシー収入',
    last29Days: '過去29日間',
    excludingToday: '今日を除く',
    commission: '手数料',
    last30Days: '過去30日間のデータ',
    rank: 'ランキング',
    hostNumber: 'ホスト数',
    recent30Days: '最近30日間のホスト収入',
    commissionRate: '手数料率',
    myCommission: '私の手数料',
    remove: '削除',
    thisAction: 'この操作により、チームから{hostoragent} {hostname}が削除されます。続行しますか？',
    dashboard: 'ダッシュボード',
    information: '情報',
    dataCenter: 'データセンター',
    hostList: 'ホスト一覧',
    bdList: 'BD一覧',
    agencyList: '代理店一覧',
    myRight: '自分の権限',
    numberOf: '代理店数',
    inviteAgency: '代理店を招待',
    numberOfHost: 'ホスト数',
    inviteHost: 'ホストを招待',
    inviteHostlinkcopied: '招待リンクをコピーしました',
    tipsShare: 'ヒント：招待リンクを友達と共有する',
    thisMonthD: '今月のデータ',
    formDay1: 'day1 から day2 まで',
    hostGift: 'ホストギフトポイント',
    agentCommission: 'エージェント手数料',
    currentLevel: '現在のレベル',
    commissionRateOf: 'エージェント収入の手数料率',
    baseSalary: '基本給与',
    stillNeed: 'まだ必要',
    toReach: '到達する',
    reachedthe: '広告タスク',
    advertisementTask: 'データ概要',
    dataOverview: 'データ概要',
    today: '今日',
    hostPoint: 'ホストポイント',
    agentsPoints: 'エージェントポイント収入',
    thisMonth: '今月',
    month: '月',
    lastMonth: '先月',
    bdNumber: 'BD数',
    hostIncome: 'ホスト収入',
    todayIncome: '本日の収入',
    past30Days: '過去30日',
    host: 'ホスト',
    country: '国',
    level7: 'レベル / 7日収益',
    pointIncome: 'ポイント収入',
    liveDuration: 'ライブ時間',
    joinTime: '参加時間',
    state: '状態',
    operation: '操作',
    bd: 'BD',
    totalHosts: 'ホスト総収入',
    totalAgents: 'エージェント総収入',
    agent: 'エージェント',
    agentLevel: 'エージェントレベル / 手数料率',
    commissionIncome: '手数料収入',
    showDirect: '直属エージェントのみ表示。本日のデータは含みません',
    excludingTodayData: '本日のデータは含みません',
    packages: 'パッケージ',
    contents: 'コンテンツ',
    balance: '残高',
    release: 'リリース',
    issue: '発行',
    createBd: 'BD作成',
    times: '回',
    authorizeCs: 'CS認証',
    giftTo: 'ユーザーに贈呈',
    bdCreation: 'BD作成制限残り',
    csAuthorization: 'CS認証割当残り',
    giftName: 'ギフト名',
    giftContents: 'ギフト内容',
    check: 'チェック',
    cancel: 'キャンセル',
    tip: 'チップ',
    recipientsVip: '受取人のVIPティアがギフトパッケージの制限を超えています。このギフトのVIP特権は無効になります。続行してもよろしいですか？',
    confirm: '確認',
    authorize: '認証',
    inviteBy: 'ユーザーIDで招待',
    invite: '招待',
    inviteLink: '招待リンク',
    copy: 'コピー',
    success: '成功',
    pleaseCheck: 'ユーザーIDを確認してください',
    totalGift: '全てのホストのギフト総収入（ランキング、タスクなどのプラットフォーム報酬を除く）、下位代理店のギフト収入を含む。',
    totalAgentsCom: 'エージェントのホスト収入からの総手数料、下位代理店の手数料を含む。',
    allAgent: '全ての代理',
    directAgent: '直接代理',
    indirectAgent: '間接代理',
    newUpgraded: '新規アップグレード代理',
    newS: '新S級代理',
    newB: '新B級代理',
    newC: '新C級代理',
    expectedReward: '期待報酬',
    newA: '新A級代理',
    agencyLevel: '代理店レベル',
    nickname: 'ニックネーム',
    upgradeDate: 'アップグレード日',
    bdPolicy: 'BDポリシー',
    agencyDetail: '代理店詳細',
    agency: '代理店',
    hostCommission: 'ホスト手数料',
    last6Days: '過去6日',
    giftIncome: 'ギフト収入',
    mins: '分',
    agencyCenter: '代理センター',
    myIncome: '今日の私の収入',
    totalHost: '総ホストポイント',
    overview: '概要',
    hostPoints: 'ホストポイント',
    myHosts: '私のホストポイント',
    subagentHost: '下位代理ホストポイント',
    subagencyNumber: '下位代理店数',
    otherIncome: 'その他の収入',
    contactAdmin: '管理者に連絡',
    whatsapp: 'ワッツアップ',
    bdCenter: 'BDセンター',
    copySuccess: 'コピー成功',
    pleaseInput: 'チャージ金額を入力してください、最低10',
    agencyPolicy: '代理ポリシー',
    agencyCommission: '代理手数料',
    agencyCommission2: '代理手数料 = 手数料率 × 全てのホストのギフト総収入（ランキング、タスクなどのプラットフォーム報酬を除く）',
    excludingPlatform: '（ランキング、タスクなどのプラットフォーム報酬を除く）',
    agencyCommissionCalculation: '代理手数料計算',
    level: 'レベル',
    pointsTarget: 'ポイント目標（過去30日）',
    points10000: '10,000ポイント = 1米ドル (M= 百万)',
    note1: '注1: 総有効収入 = あなたの代理店収入 + 下位各階層の代理店収入',
    note2: '注2: ホストがギフトを受け取ると、代理店手数料はリアルタイムで入金されます。',
    note3: '注3: 最低出金額は10米ドルであり、出金額は10の倍数でなければなりません（例：10米ドル、20米ドル、30米ドル）。',
    subagencycommission: '下位代理店手数料',
    theMain: 'メイン代理店は、下位代理店の各ティア（T1、T2、T3、T4...Tn）の収入から手数料を得ることができ、最大手数料率は16%です。',
    forExample: '例：',
    agencyA: '代理店Aが代理店Bと代理店Cを招待します。',
    agencyB: '代理店Bが代理店Dと代理店Eを招待します。',
    agencyC: '代理店Cが代理店Fを招待します。',
    noteFigures: '(注：括弧内の数字は各代理店の所属ホストの収入を表します)。',
    thusWe: 'したがって、代理店Aから代理店Fまでの総有効収入と手数料率を計算できます。',
    totalValid: '総有効収入 = あなたの代理店の収入 + 下位各層の代理店の収入',
    aTotal: 'A総有効収入 = A + B + C + D + E + F = 10M + 20M + 70M + 20M + 30M +80M = 230M（20%手数料率）',
    bTotal: 'B総有効収入 = B + D + E = 20M + 20M + 30M = 70M（16%手数料率）',
    cTotal: 'C総有効収入 = C + F = 70M + 80M =150M（20%手数料率）',
    dTotal: 'D総有効収入 =20M（12%手数料率）',
    eTotal: 'E総有効収入 =30M（12%手数料率）',
    fTotal: 'F総有効収入 =80M（16%手数料率）',
    subagencyCommission: '下位代理店手数料 = (メイン代理店手数料率 - 下位代理店手数料率) × 下位代理店の総有効収入',
    agencyAC: '代理店{A}から代理店{B}への手数料',
    thereforeAgency: 'したがって、代理店{A}が下位代理店から得る総手数料',
    sinceAgency: '代理店D、E、Fには下位代理店がないため、下位代理店手数料を獲得できません。',
    seniorPolicy: 'シニアポリシー',
    nomore: 'これ以上のデータはありません',
    active: 'アクティブ',
    disabled: '無効化',
    deleted: '削除済み',
    lastLogintime: '最終ログイン時間',
    onmic: '今日マイクオン'
  },
  sellerCoin: {
    detailsOf: '出金詳細',
    fundsSent: '資金送金済み',
    transfer: '振込',
    totalIncome: '総収入',
    orderIncome: '注文収入',
    estimatedReward: '見積報酬',
    amount: '金額',
    applicantId: '申請者ID',
    applicantName: '申請者名',
    orderId: '注文ID',
    uploadScreenshot: 'スクリーンショットをアップロード',
    ensureWithdrawal: '出金が成功したことを確認した後、スクリーンショットをアップロードし、下のボタンをクリックして申請者に通知してください。',
    remain: '残り',
    pleasePay: 'すぐに支払いを完了し、領収書をアップロードしてください。時間を超えると、注文の支払い資格はキャンセルされます。',
    youCan: '1日あたり最大5,000招待ポイントを獲得できます',
    pleaseComplete: 'お早めに出金を完了してください ',
    unableTo: '支払い不能、拒否',
    notifyThe: '申請者に通知',
    youCanGet: '注文を適時に処理すると、1%～3%の追加ボーナスを獲得できます。',
    ifYou: '30分以内に注文を処理すると、3%のボーナスを獲得できます。',
    egThe: '例：90,000ポイント相当の注文を30分以内に処理すると、3%のボーナスを獲得でき、90,000 × 3% = 2,700ポイントとなります。',
    gotIt: '了解しました',
    pleaseUpload: '画像をアップロードしてください',
    detail: '詳細',
    balance: 'Balance',
    exchange: '交換',
    all: 'すべて',
    recharge: 'チャージ',
    official: '公式',
    exchangeDetail: '交換詳細',
    coinSeller: 'コイン販売者',
    levelUp: 'レベルアップ',
    currentLevel: 'Current level',
    myBalance: '私の残高',
    details: '詳細',
    paymentMethod: 'お支払い方法',
    myOrder: '私の注文',
    paymentMenthod: 'お支払い方法',
    acceptingOrders: '注文受付中',
    unavailable: '利用不可',
    greetingMessage: '挨拶メッセージ設定',
    serviceUnavailable: 'サービス利用不可',
    thisFeature: 'この機能は一時的にロックされています。サポートにお問い合わせください。',
    editMessage: 'メッセージを編集',
    customizeYour: '挨拶メッセージをカスタマイズします。コインのリチャージに関する役立つ情報を含めることができます。',
    theMessage: '新しいユーザーがあなたとプライベートチャットを開始すると、メッセージが自動的に送信されます',
    save: '保存',
    pleaseEnterMessge: '挨拶メッセージを入力してください',
    salesMethod: '販売方法',
    user: 'ユーザー',
    coinseller: 'コインセラー',
    userId: 'ユーザーID',
    check: 'Check',
    coinAmount: 'コイン量',
    pleaseEnter: '1の倍数を入力してください',
    enterAt: '少なくとも100を入力してください、1の倍数で',
    transferDetails: '転送詳細',
    recommendSeller: '販売者を推薦',
    recent30Day: '最近30日間のコイン販売',
    whatsapp: 'WhatsApp',
    chat: 'チャット',
    yourCountry: 'お住まいの国には現在、利用可能なコイン販売者がありません。',
    pleaseContact: 'カスタマーサポートにお問い合わせください。',
    customerSupport: 'カスタマーサポート',
    contact: '連絡',
    customRecharge: 'カスタムチャージ',
    rechargeDetails: 'チャージ詳細',
    myPoints: 'マイポイント',
    todayRemaining: '本日の残りクォータ',
    customExchange: 'カスタム交換',
    exchangeDetails: '交換詳細',
    rechargeRules: 'チャージルール',
    sellerLevel: '販売者レベル',
    proportion: '比例',
    levelRequirement: 'レベル要件',
    beginner: '初心者',
    singleRecharge: 'シングルチャージ',
    standard: '標準',
    senior: 'シニア',
    exchangeRules: '交換ルール',
    note: 'Note',
    seniorCoin: 'シニアコイン販売者は毎日ポイントを無料で獲得します。追加で',
    beginnerSeller: '初心者販売者',
    standardSeller: '標準販売者',
    seniorSeller: 'シニア販売者',
    cancel: 'Cancel',
    pleaseInput: 'Please input the recharge amount, minimum 10',
    pleaseInput2: 'チャージ金額を入力してください、100Kの倍数',
    confirmation: '確認',
    userName: 'ユーザー名',
    theUser: 'ユーザーはブラックリストに登録されました',
    enterAmount: '金額を入力',
    pleaseInput3: '金額を入力してください',
    theAmount: '金額は100000の倍数でなければなりません',
    pleaseInput4: '金額を入力または選択してください',
    pleaseSelect: '販売方法を選択してください',
    pleaseInput5: 'ユーザーIDを入力してください',
    atLeast: '少なくとも100Kコインを転送してください~',
    pleaseSelect2: 'お支払い方法を選択してください',
    minimum: '最低',
    theAmount3: '金額は1の倍数でなければなりません',
    lessThan: '100000以下',
    orders: '注文',
    applicant: '申請者',
    method: '方法',
    withdrawTime: '引き出し時間',
    viewDetail: '詳細を見る',
    toBe: '確認待ち',
    toBePaid: '支払い待ち',
    toBeCompleted: '完了待ち',
    completed: '完了',
    abnormal: '異常',
    refused: 'Refused',
    confirmationTimeout: '確認タイムアウト',
    paymentTimeout: '支払いタイムアウト',
    binance: 'バイナンス',
    scanThe: 'QRコードをスキャンして支払う',
    quantity: '数量',
    orderAmount: '注文金額',
    date: '日付',
    payNow: '今すぐ支払う',
    payment: '支払い',
    pleasePay2: '以下の方法でお支払いください',
    chainName: 'チェーン名',
    contractAddress: '契約アドレス',
    theAbove: '上記のアドレスはこの充電にのみ有効です',
    copy: 'Copy',
    notice: '通知',
    pleaseTransfer: 'Binanceの手数料をカバーするために追加で1 USDTを送金してください。そうしないとコインのチャージが遅れる可能性があります。',
    paymentsMust: '支払いは0.5時間以内に完了する必要があります。そうしないと、プラットフォームは問題に対して責任を負いません。',
    add: '追加',
    confirmTo: 'この支払い方法を削除することを確認します',
    countryCurrency: '国と通貨タイプ',
    selectPayment: '送金可能な支払い方法を選択してください',
    coinsSeller: 'コイン販売者ルール',
    standrd: '標準',
    salesMethods: '販売方法',
    coinsellerRules: 'コインセラールール',
    whenApplying: 'コイン販売者のステータスへのアップグレードを申請する場合、預金要件はなく、コイン販売者のレベルをアップグレードするには1回のチャージのみが必要です。コイン販売者の職務から辞任することを選択した場合、現在のコイン販売者の役割は期限切れになります',
    youCanReplenish: 'あなたはUSDT、Epayで直接、または別のコイン販売者を通じてアカウントを補充できます',
    fraudulentActivities: 'Halaプラットフォーム内では詐欺行為は固く禁じられています。',
    anyViolations: '違反があるとコイン販売者のアカウントが終了します',
    allRights: 'すべての権利はHalaに帰属します。',
    transferDetail: '転送詳細'
  },
  centerHost: {
    baseSalary: 'Base Salary',
    invitation: '招待',
    tasks: 'タスク',
    other: 'その他',
    consume: '消費',
    giftIncome: 'Gift Income',
    received: '受け取り済み',
    from: 'から',
    luckyGift: 'ラッキーギフト',
    hostCenter: 'ホストセンター',
    noAgent: 'エージェントなし',
    last7: '過去7日間',
    hourlyIncome: '時間当たり収入',
    toReach: 'to reach',
    rules: 'ルール',
    pointsOverview: 'ポイント概要',
    totalIncome: 'Total Income',
    gifts: '贈り物',
    workDetail: '作業詳細',
    liveDuration: 'Live Duration',
    mins: 'mins',
    todaysLive: '本日のライブ記録',
    dailyStatistics: '日次統計',
    startTime: '開始時間',
    endTime: '終了時間',
    duration: '期間',
    points: 'ポイント',
    date: 'Date',
    giftPoints: 'ギフトポイント',
    removeBinding: 'バインディングを解除',
    thisAction2: 'このアクションにより、{agentName}とのバインドが解除されます。バインド解除を続行するか確認してください'
  },
  bombRule: {
    afterThe: 'ルーム内の爆発値が一定量に達すると、ギフト爆弾がルーム内に表示されます',
    oneCoins: 'ルームで受け取った1コイン=1爆発値',
    itWill: '条件を満たすと自動的に爆発し、ルームオーナーは対応する金貨の報酬を受け取ります'
  },
  descriptionLevel: {
    wealth: '富',
    charm: '魅力',
    wealthValue: '富の価値',
    charmValue: '魅力値',
    needTo: '必要',
    send: '送信',
    receive: '受信',
    forThe: 'アップグレード用',
    theRich: 'リッチレベルは、チャージしたコインでカウントされます',
    theCharm: 'チャームレベルは、受け取ったコインの数に基づいて計算されます',
    LevelLabel: 'レベルラベル',
    level: 'Level',
    levelLogo: 'レベルロゴ'
  },
  gameRank: {
    gameRank: 'ゲームランク',
    rules: 'Rules',
    thisWeek: '今週',
    lastWeek: '先週',
    agentGaming: 'エージェントゲーミング収益ランキング',
    rankingRewards: 'ランキング報酬',
    rankingIs: 'ランキングは、エージェントのルームとそのサブルームにおけるユーザーの総ベット額に基づいています。',
    hostRoom: 'ホストルーム収益ランキング',
    rankingIs2: 'ランキングは、ホストのルームで生成された総ゲーム収益に基づいています。',
    notes: '備考',
    eventDuration: 'イベント期間：各暦週。報酬は以下の場合にのみ配布されます',
    rewardsAre: 'Rewards are distributed only if the corresponding revenue requirements are met.',
    allRewards: 'All rewards will be issued within 1-2 working days after the event ends.',
    halaReserves: 'Halaは本イベントの最終的な解釈権を留保します',
    rewardsDetail: '報酬詳細',
    decorationsPreview: '装飾プレビュー'
  },
  gameLegacyHall: {
    surpriseLucky: 'サプライズラッキーバッグ',
    dailyPlayers: 'デイリープレイヤーは翌日ラッキーバッグを開けてランダムなコインを獲得できます',
    eventRule: 'イベントルール',
    usersSpending: 'イベントゲームでのユーザーの支出は、ランキングスコアにカウントされます',
    thePlatform: 'プラットフォームは4時間ごとにイベントゲームをローテーションし、各ローテーションで4つの異なるゲームを特集します',
    theTop: 'デイリー上位3名のプレイヤーはフレームとコイン報酬を受け取ります',
    theTop2: '週間上位10名のプレイヤーはフレームとコイン報酬を受け取ります',
    usersWho: '毎日イベントゲームに参加するユーザーは、翌日ラッキーバッグを開けてランダムな量のコインを受け取ることができます。イベントゲームで使うほど、より多くのコインを獲得できる可能性があります',
    behindPrevious: '前回から遅れて',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    countdown: 'カウントダウン：',
    days: '日',
    winOver: '以上獲得',
    coinsfrom: '1日でゲームから獲得するコイン',
    earnOver: '以上獲得',
    coinsWitdh: '還元率は最大',
    fromOneDay: 'のある1日から',
    game: 'ゲーム',
    fromA: 'での単一ベットから',
    inthisWeek: '今週中',
    earnUp: '最大まで獲得',
    inAsingle: '1日で',
    eventRules: 'イベントルール',
    participateIn: '明日もっと大きなラッキーバッグを受け取るためにゲームに参加してください',
    youDid: 'コイン報酬を受け取りませんでした。ゲームに参加すると、明日もラッキーバッグを受け取り続けることができます',
    participateIn2: 'ゲームに参加すると、明日もラッキーバッグを受け取り続けることができます',
    topDaily: 'デイリーコイン勝者トップ',
    topPayout: '最高配当率勝者',
    topCoins: '週間1ラウンドコイン勝者トップ',
    topPayout2: '週間1ラウンド最高配当率勝者',
    topWeekly: '週間コイン勝者トップ',
    historicalTop: '歴史的1日コイン勝者トップ',
    historicalTop2: '歴史的1日最高配当率勝者',
    historicalTop3: '歴史的1ラウンドコイン勝者トップ',
    historicalTop4: '歴史的1ラウンド最高配当率勝者',
    historicalTop5: '歴史的1週間コイン勝者トップ',
    gameReward: 'ゲーム報酬',
    usersSpending2: 'イベントゲームでのユーザーの支出は、ランキングスコアにカウントされます',
    theTop3: 'デイリー上位3名のプレイヤーはフレームとコイン報酬を受け取ります',
    theTop4: '週間上位10名のプレイヤーはフレームとコイン報酬を受け取ります',
    usersWho2: '毎日イベントゲームに参加するユーザーは、翌日ラッキーバッグを開けてランダムな量のコインを受け取ることができます。イベントゲームで使うほど、より多くのコインを獲得できる可能性があります',
    coins: 'コイン',
    flameRider: 'フレームライダー',
    sportCar: 'スポーツカー',
    captainMeow: 'キャプテンミャウ',
    profileFrame: 'プロファイルフレーム'
  },
  gold: {
    coinsDetail: 'コイン詳細',
    coinBalance: 'コイン残高',
    all: 'ALL',
    sendGifts: 'ギフトを送る',
    purchaseItems: 'アイテムを購入',
    games: 'ゲーム',
    exchange: 'Exchange',
    recharge: 'Recharge',
    activeReword: 'アクティビティ報酬',
  },
  integral: {
    all: 'All',
    cashOut: '現金化',
    transfer: 'Transfer',
    orderId: 'Order ID',
    paymentMenthod: 'Payment Menthod',
    withdrawalTime: '引き出し時間',
    pointsAmount: 'ポイント数',
    depositAmount: '入金額',
    coinsAmount: 'コイン量',
    transferTo: 'に振り込む',
    normal: '正常',
    pending: '保留中',
    success: 'Success',
    failed: '失敗',
    points: 'Points',
    pointsBalance: 'ポイント残高',
    frozenPoints: '凍結ポイント',
    details: 'Details',
    exchange: 'Exchange',
    currencyType: '通貨タイプ',
    paymentMethod: 'Payment method',
    pointsAmount2: '現金化するポイント数',
    enterA: '100,000の倍数を入力してください（最低200,000）',
    enterA2: '100000の倍数を入力してください',
    accountInformation: 'アカウント情報',
    withdraw: '引き出す',
    amount: 'Amount',
    exchangeRate: '為替レート',
    exchangePoints: '交換ポイント',
    enterUserId: 'ユーザーIDを入力',
    check: 'Check',
    fee: '手数料',
    theAgency: '代理店が受け取ります',
    transferFee: '振込手数料：2%。最低振込≥100,000ポイント。',
    clickTransfer: '転送ボタンをクリックして、対応するポイントをエージェントに転送します',
    afterThe2: '転送が完了すると、キャンセルまたは撤回できません',
    transferPoints: 'ポイントを振り込む',
    recommendedMethod: '推奨方法',
    lowerFees: '低料金かつ24時間以内に審査',
    paymentPassword: '支払いパスワードが設定されていません',
    cashOut2: '現金化と交換には支払いパスワードの確認が必要です。最初に支払いパスワードを設定してください。',
    cancel: 'Cancel',
    goTo: '設定へ移動',
    youHave: '5回の失敗試行に達しました。さらに1回失敗するとアカウントが凍結されます。パスワードをお忘れの場合は、再設定してください。',
    inputIncorrect: '何度も間違ったパスワードを入力しました。アカウントが凍結されました。後ほど再試行してください',
    verify: '確認',
    gotIt: 'Got it',
    pointsInfo: 'ポイント情報',
    whenA: 'ユーザーがGoogle経由でチャージされたコインを使用してギフトを送信すると、受け取ったポイントは利用可能になる前に7日間凍結されます。ユーザーが返金を要求した場合、それらのポイントは差し引かれます。プラットフォームのルールに従い、違反を避けてください。',
    frozenPointsAre: '凍結ポイントは総ポイント残高に含まれます',
    theUser2: 'ユーザーはブラックリストに登録されました',
    successfulWithdrawal: '引き出し成功',
    withdrawalAmount: '引き出し金額',
    theFunds: '資金は24時間以内に入金されます',
    pleaseEnter2: 'パスワードを入力してください',
    passwordIncorrect: 'パスワードが間違っています',
    theAmount4: '金額は100000の倍数でなければなりません',
    pleaseEnter3: 'ユーザーIDを入力してください',
    pleaseEnter4: '正しいユーザーIDを入力してください',
    pleaseEnter5: '金額を入力してください',
    minimumTransfer: '最低振込≥100,000ポイント',
    pleaseSelect3: '方法を選択してください',
    minimum: 'minimum',
    theAmount5: '金額は以下でなければなりません',
    illegalInput: '不正な入力',
    pleaseEnter6: 'アカウント情報を入力してください'
  },
  invite: {
    inviteGame: 'ゲームユーザーを招待',
    currentRebate: '現在のリベート',
    need: '必要',
    toProgress: '次のレベルに進むために',
    gameReward: 'Game Reward',
    referralData: '紹介データ',
    referralList: '紹介リスト',
    date: 'Date',
    gameBets: 'ゲームベット',
    inviteRewards: '招待報酬',
    viewMore: 'もっと見る',
    inviteFriends: '友達を招待',
    myReward: 'マイ報酬',
    totalRewards: '総報酬',
    dailyReward: 'デイリー報酬',
    inviteRules: '招待ルール',
    yourRebate: 'あなたのリベート率は、過去30日間の総有効ベット額によって決まります',
    totalValid2: '総有効ベット = 自身のベット + 招待したユーザーの各ティアの自身のベット',
    rebateFrom: 'Tier-1招待ユーザーからのリベート = 自身のベット × リベート率',
    rebateFrom2: 'Tier-2招待ユーザーからのリベート = 自身のベット × (リベート率 - Tier-1リベート率)',
    ifThe: 'Tier-2招待ユーザーがTier-3ユーザーを招待した場合、総有効ベット額を増やすことができますが、Tier-3からリベートを得ることはできません。',
    example: '例',
    tier1: 'Tier-1招待 - 直接招待した人からのリベートを計算する方法は？',
    asRebate: 'B、C、DからのAのリベート = (Bの自身ベット + Cの自身ベット + Dの自身ベット) × Aのリベート率 =',
    bsRebate: 'EとFからのBのリベート = (Eの自身ベット + Fの自身ベット) × Bのリベート率 =',
    csRebate: 'GからのCのリベート = Gの自身ベット × Cのリベート率 =',
    tier2: 'Tier-2招待 - 間接的に招待した人からのリベートを計算する方法は？',
    asRebate2: 'EとFからのAのリベート = (Aのリベート率 - Bのリベート率) × (Eの自身ベット + Fの自身ベット) =',
    asRebate3: 'GからのAのリベート = (Aのリベート率 - Cのリベート率) × Gの自身ベット =',
    myInvitation: 'マイ招待',
    search: 'Search',
    invitationTime: '招待時間',
    inviteHost: 'Invite Host',
    inviteA: 'ホストを招待、それぞれ最大',
    todayRewards: '本日の報酬',
    rewardDetail: '報酬詳細',
    creatorRewards: 'クリエイター報酬ウォレット',
    collect: '受け取る',
    invitationDate: '招待日',
    hostPolicy: 'ホストポリシー',
    halaReserves2: 'Halaは上記ポリシーの最終的な解釈権を留保します。'
  },
  listContribution: {
    contributiont: '貢献',
    host: 'Host',
    wealth: 'Wealth',
    today: 'Today',
    yesterday: '昨日',
    game: 'Game',
    gift: '贈り物',
    hostEarnings: 'ホスト収益'
  },
  missionRule: {
    hostPolicy: 'Host Policy',
    halaReserves3: 'Halaは上記ポリシーの最終的な解釈権を留保します'
  },
  purchase: {
    recharge: 'Recharge',
    userId: 'User ID',
    confirm: 'Confirm',
    switchAccount: 'アカウント切替',
    countryRegion: '国/地域',
    officialAgency: '公式代理店チャージ',
    ttOff: '20%オフ',
    totalAmount: '合計金額',
    purchase: '購入',
    pleaseComfirm: 'ユーザーIDを確認してください',
    pleaseInput8: 'ユーザーIDを入力してください',
    onlineService: 'オンラインサービス',
    dealOf: '過去30日間の取引',
    recent30Day2: '最近30日間のコイン販売',
    paymentMethod: 'Payment Method',
    whatsapp: 'WhatsApp',
    chat: 'Chat',
    yourCountry2: 'お住まいの国には現在、利用可能なコイン販売者がありません',
    pleaseContact2: 'カスタマーサポートにお問い合わせください。',
    customerSupport: 'customer support',
    contact: 'Contact'
  },
  roomGiftRule: {
    eventRules: 'Event Rules',
    treasureChest: 'ルーム内でギフトを贈ることで宝箱の進行度が増加します',
    whenThe: '宝箱の鍵の進行バーが満タンになると、宝箱が開きます',
    afterThe3: 'レベル3およびレベル4の宝箱が条件を満たすと、1分間ロックされ、自動的に開きます',
    everyoneIn: '部屋にいる全員が宝箱の中の報酬を獲得するチャンスがあります',
    onceThe: '宝箱を開けた後、システムからアカウントに報酬が付与されるまで数分かかる場合があります。ゴールドコインは残高に追加され、コスチュームはインベントリに追加されます。',
    theHigher: '宝箱のレベルが高ければ高いほど、中の報酬も大きくなります',
    ifYou2: '現在のVIPレベルよりも低いVIPレベルに選ばれた場合は、VIPレベルは適用されません。',
    theProgress: 'チェストキーの進捗バーは毎日00:00（UTC+5:30）にリセットされます。'
  },
  share: {
    joinHala: 'Hala に参加して、複数の収益機会を獲得し、代理店向けのカスタマイズされた特典と報酬をお楽しみください。',
    downloadTo: 'パートナーになるにはダウンロードしてください',
    joinHala2: 'Hala に参加して楽しいゲームを楽しみ、素晴らしい賞品を獲得するチャンスを手に入れましょう。',
    downloadAnd: 'ダウンロードして勝利を掴もう',
    joinHala3: 'Halaに参加してホスティングの旅を始めましょう。毎日最大36ドルのボーナスを獲得できます！',
    inviteYou: 'エージェンシーへの参加を招待',
    downloadNow: '今すぐダウンロードしてホスティングを開始',
    comeWith: 'ハラのチャットルームに一緒に参加しましょう',
    enthusiastsFrom: '世界中の愛好家が集まり、共有します...',
    igniteEndless: '無限の楽しみを巻き起こす',
    download: 'ダウンロード',
    halaLive: 'ハラライブ',
    showMe: 'ショー・ミー・ハッピー・ザ・ワールド',
    saySomething: '何か言って...',
    downloadHala: 'Halaアプリをダウンロード'
  },
  starHost: {
    starHost: 'スターホスト',
    level2: 'レベル{level}は{days}日間維持されました',
    currentSalary: '現在の給与',
    points: 'Points',
    likes: 'いいね',
    stillNeed: 'Still need',
    done: '終わり',
    numberOf2: '贈与者の数',
    gifters: '贈り主',
    gcoinGifts: 'Gコインギフト',
    gifts: 'gifts',
    liveDuration: 'Live Duration',
    min: '分',
    completeAll: 'アップグレードするには、以下のタスクをすべて完了してください',
    follower: 'フォロワー',
    numberOf3: '贈与者の数',
    daysAt: '{level} レベルの日数',
    giftCollection: 'ギフトコレクション',
    gift: 'Gift',
    date: 'Date',
    expectedSalary: '希望給与',
    gcoin: 'Gコイン',
    status: '状態',
    levelReached: ' レベルに到達しました',
    notAchieved: '達成されなかった',
    starHost2: 'スターホストのルール',
    eachStar: '各スターホストには3日間の試用期間があります',
    theyWill: '3日間すべてAレベルの基準を満たした場合にのみ、公式スターホストになることができます。',
    thoseWho: '毎日のAレベルの目標を達成できなかった者は解雇される',
    firedHosts: '解雇されたホストはスターホストの基本給をもらえない',
    starHost3: 'スターホストの基本給は毎週月曜日に支払われます',
    ifA: 'スターホストが毎日のタスクを完了できなかった場合、時給の50％しか受け取れません。',
    selfGifting: 'すべてのギフト対象者へのセルフギフトは固く禁じられています',
    starHost4: 'さまざまなレベルのスターホスト報酬',
    level: 'Level',
    dailyExtra: '毎日の追加ポイント報酬',
    liveBroadcast: 'ライブ放送に必要な時間',
    starHost5: 'さまざまなレベルのスターホスト要件',
    requirements: '要件）',
    yourApplication: 'あなたの申請は公式に承認されました',
    stayOn: 'Aレベルに7日間滞在',
    over1k: '1,000人以上のファン',
    totalGifter: '贈与者総数 > 300',
    receiveAll: 'すべての「ラッキー」ギフトを受け取る',
    everyLucky: '幸運の贈り物の数字はすべて100以上である必要があります',
    stayOn2: 'Sレベルに10日間滞在',
    over2k: '2,000人以上のファン',
    totalGifter2: '贈与者総数 > 300',
    receiveAll2: 'すべての「ホット」ギフトを受け取る',
    stayOn3: 'SSレベルに10日間滞在',
    over5k: '5,000人以上のファン',
    totalGifter3: '贈与者総数 > 1000',
    receiveAll3: 'すべての「ラグジュアリー」ギフトを受け取る',
    starHost6: 'スターホストの毎日のタスク',
    dailyAssessment: '（毎日の評価システム）：交流/贈り物',
    gcionGifts: 'Gcionギフト',
    rulesTo: 'スターホストレベルを下げるルール',
    failTo: '現在のレベルの基準を 3 日連続で満たせません。',
    failingTo: '1週間以内に基準を満たさなかった回数<span>3回',
    ifThe2: 'ホストがAレベルの場合、毎日の基準を満たさない場合、降格ではなく直接解雇されます。降格後、元のレベルに戻るには、元のレベルの基準を3日間連続で満たす必要があります。',
    involvementIn: '重大な違反または否定的な事件への関与。',
    causingDamage: 'プラットフォームの利益やブランドイメージに損害を与える',
    applyFor: '自分で禁煙を申請する',
    liveStreaming: 'ライブストリーミングの要件',
    liveStream: 'ライブストリームコンテンツはホストの指定タイプに一致している必要があります',
    roomHosts: 'ルームホストは、放送中に長時間マイクをミュートすることは禁止されています。',
    liveStreams: 'ライブ ストリームは、9 席のマイクの部屋レイアウトを使用して実施する必要があります。',
    otherSeats: 'タスクファーミングの目的でマイクをミュートしているユーザーや観客は、室内の他の座席に座ることはできません。',
    discriminatoryInsulting: '部屋内での差別的、侮辱的、または不快な発言は固く禁じられています'
  },
  starRoom: {
    afterCountdown: '毎日カウントダウン後、トップ3の部屋がスタールームランキングに表示されます。',
    top20Star: '今週以降、トップ20スタールームには豊富なボーナスが付与されます',
    countdown: 'Countdown：',
    top3Daily: '毎日のトップ3ルームは、毎週のスタールームに参加する資格があります',
    starRooms: 'スタールームは週の最終日にランク付けされます。ランク付けは各ルームのコインフローの合計に基づいて行われます。',
    top20Weekly: '毎週トップ20のスタールームオーナーには、以下の報酬が与えられます。',
    qualificationTo: 'このイベントに参加するための資格：ルーム内でのいかなる違反や違法行為も許可されません。発見された場合、Halaはルームを失格にし、ランクから削除します。',
    theRewards: '報酬は毎週月曜日に発送されます。',
    days: 'days',
    coins: 'Coins'
  },
  inviteActive: {
    inviteHosts: 'ホストを招待する',
    pointsMax: '1日最大5,000ポイント',
    firstRecharge: '初回チャージユーザー',
    get20: '20ドルを無料でゲット',
    oneInvite: '1. 招待したホストが終了したら、ライブを開始するようにホストを招待します。',
    aFinish: 'a. タスクセンターで顔認証を完了する',
    bCreate: 'b.自分の部屋を作る',
    cLive: 'c.彼女の部屋で3時間マイクで生放送',
    dClaim: 'd.ライブ報酬を初めて受け取る',
    youGet: '招待されたホストの有効な番号に応じて、毎日ポイント報酬を獲得できます。報酬は翌日に受け取ることができます。',
    validHost: '有効なホスト',
    pointsReward: 'ポイント報酬',
    youCan: ' You can earn up to 5,000 invite points per day',
    myInvited: '招待されたホスト',
    validHosts: '今日の有効なホスト',
    pointsRewards: 'ポイント報酬',
    validHosts2: '昨日の有効なホスト:',
    claim: '請求',
    claimed: '主張した',
    completedTime: '完了時間',
    ifYour: 'フレンドが先にリチャージを完了すると、たくさんの報酬を獲得できます。(オフラインリチャージも含まれます)',
    theMore: '最初のチャージ金額が多ければ多いほど、より多くのコインが報酬として与えられ、1日あたり最大 20 ドルになります。',
    inviteesRecharge: '招待者コインをチャージ',
    yourReward: '報酬コイン',
    threeOnly: '3. 30日以内に再チャージを招待されたユーザーのみが、有効な初回再チャージユーザーとしてカウントされます。',
    seniorAnd: '上級販売者および標準販売者は、アプリまたは公式から直接チャージした場合にのみカウントされます（支払い方法については管理者にお問い合わせください）。初めてチャージしたユーザーは、有効な初回チャージユーザーとしてカウントされます。',
    myInvited2: '招待したユーザー',
    rechargeCoins: 'コインをチャージする',
    coinsRewards: 'コイン報酬',
    firstRecharge2: '昨日の初回チャージコイン:',
    firstRecharge3: '初回チャージコイン',
    firstRecharge4: '初回充電時間'
  },
  hostPolicy: {
    title: 'ホストポリシー',
    section1Title: '新規ホストの初週基本給',
    requirement: '要件',
    newHostsDesc: '最初の週にHalaに参加した新規ホスト',
    activeTime: 'マイクでのアクティブ時間',
    oneHour: '1時間',
    twoHour: '2時間',
    threeHour: '3時間',
    baseSalary: '基本給（ポイント）',
    incomeRequirement: '収入要件',
    none: 'なし',
    remarks: '備考',
    remarksDesc: '最大3時間/日。最大7日間。最大報酬は計35,000ポイント',
    note1: 'ホストの登録日から、7日間の基本給有効期間のカウントダウンが開始されます。',
    note2: '複数のアカウントを使用している場合、または複数のIPやデバイスでログインするホストは、基本給報酬の対象から外されます。',
    note3: 'ホストの過去7日間の収入が150,000ポイントを超える場合、新規ホスト基本給報酬の代わりに通常ホスト時間給報酬を受け取ります。',
    section2Title: '通常ホスト均等待遇報酬',
    level: 'レベル',
    incomeRequirementShort: '収入要件',
    hourlyReward: '時間給報酬',
    maximumDailyHours: '1日の最大時間',
    section2Note1: 'マイクで連続15分間が有効時間としてカウントされます。',
    section2Note2: 'すべての報酬はポイントで決済され、タスクシステムで請求する必要があります。',
    section2Note3: 'プラットフォーム報酬はポイント要件にカウントされません。',
    section2Note4: '複数のIPまたはデバイスが検出されると、ポイントが差し引かれます。',
    section2Note5: '過去7日間とは過去6日間＋今日を意味するため、より高いポイントレベルにタイムリーに到達すると、時間給報酬が増える可能性があります。',
    section2Note6: 'Lレベルの非目標報酬は、登録後の最初の7日間のみ有効です。7日後、ホストは永久的に毎日500無料ポイントを取得できます。',
    section3Title: 'ホスト規定',
    regulation1: 'ホストによる複数アカウントの登録は禁止されています。',
    regulation2: 'サードパーティプラットフォームの宣伝は禁止されています。',
    regulation3: '未成年は厳格に禁止されています。',
    regulation4: 'ホストは1つの認証IDしか持てません。認証されたIDのみがライブストリーミングを開始し、収益を引き出すことができます。',
    regulation5: 'ライブストリーミングを開始するための顔認証をなりすます行為、または収益を引き出すための行為は永久に禁止されます。',
    regulation6: 'ライブストリーミングのために他人にIDを提供すると、そのIDはシステムによって永久に禁止されます。',
    regulation7: 'ボイスルームでは、ホストはルームに入るユーザーに積極的に挨拶する必要があります。',
    regulation8: 'ボイスルームのカバー写真には、ホストの実際のコンプライアンス写真を使用する必要があります。',
    regulation9: 'Halaプラットフォームは不正行為を厳格に禁止しています。違反するとアカウントが永久停止されます。',
    footer: 'Halaは上記のポリシーの最終解釈権を留保します。',
  },
  correspondingRevenue: '対応する収益要件が満たされた場合。すべての報酬は発行されます',
  within12: 'イベント終了後1〜2営業日以内'
}
